import { Route, Redirect } from 'react-router-dom';
import { getSessionStatus } from '../session/auth.js';
import routes from '../routes/routes.json';

const route = routes.contentroutes;

export default function ProtectedRoute({ component: Component, ...rest }) {
  let sessStatus = getSessionStatus();

  return (
    <Route {...rest} render={(props) => (
      sessStatus ?
        <Component {...props} />
        :
        <Redirect to={{ pathname: route.login, state: { from_url: props.location } }} />
    )} />
  )
}